import { Platform } from 'react-native';

import { useFeatureFlag } from '@order/LaunchDarkly';

export const useLocationPermissionPrimerEnabled = () => {
  const locationPrimerVariation = useFeatureFlag('CELS-5256-geofencing-primer-variant');

  const supportedVariants: (typeof locationPrimerVariation)[] = ['A', 'B', 'C'];
  const isSupportedVariant = supportedVariants.includes(locationPrimerVariation);

  return {
    isLocationPrimerEnabled: Platform.OS !== 'web' && isSupportedVariant,
    locationPrimerVariation,
  };
};
